import { useEffect, useState } from "react";

import useAxios from '../../../hooks/useAxios';
import { AxiosPublic } from "../../../config/axios";

const Wages = () => {
    const { AxiosPrivate } = useAxios()
    const [state, setState] = useState()
    const [updated_at, setUpdated_at] = useState()
    const [reload, setReload] = useState()

    useEffect(() => {
        const get = async () => {
            await AxiosPublic.get('wages')
                .then(res => {
                    setState(Number(res.data.data.value))
                    setUpdated_at(res.data.data.updated_at)
                })
                .catch(err => alert(err.response?.data.message))
        }
        get()
    }, [reload])


    const handleChange = async (e) => {
        e.preventDefault()
        await AxiosPrivate.put('wages/update', { value: e.target.children[0].children[0].children[0].value })
            .then(res => {
                alert(res.data.message)
                setReload(Math.random())
            })
            .catch(err => alert(err.response?.data.message))
    }
    return (
        <>
            {state !== undefined && <div className="p-2">
                <form className="flex gap-6 flex-col items-start" onSubmit={handleChange}>
                    <div className="flex items-center gap-4">
                        <div className="relative">
                            <input type="number" defaultValue={state} id="1"
                                className={`block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 appearance-none dark:text-white focus:outline-none focus:ring-0 peer`} placeholder="" />
                            <label htmlFor='1' className={`absolute text-nowrap rounded-lg text-sm duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto`}>اجرت</label>
                        </div>
                        <span>تومان</span>
                    </div>
                    <div className="w-full flex sm:items-center items-start gap-4 sm:text-base text-sm sm:flex-row flex-col">
                        <p>ویرایش: {new Date(updated_at).toLocaleString('fa-IR')}</p>
                    </div>
                    <button className="text-white me-3 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br  focus:outline-none shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center">ویرایش</button>
                </form>
            </div>}
        </>
    );
};

export default Wages;